export default __webpack_public_path__ + "static/media/error.b802cfa7.svg";